import React, { useState } from 'react';
import './App.css';
import HomeScreen from './components/HomeScreen/HomeScreen';
import LoginScreen from './components/LoginScreen/LoginScreen';
import HrmsHomeScreen from './components/HrmsHomeScreen/HrmsHomeScreen';

function App() {
  const [currentScreen, setCurrentScreen] = useState('home'); // 'home', 'login', or 'hrms'

  return (
    <div className="App">
      {currentScreen === 'home' && (
        <HomeScreen onGetStarted={() => setCurrentScreen('login')} />
      )}
      {currentScreen === 'login' && (
        <LoginScreen onLoginSuccess={() => setCurrentScreen('hrms')} />
      )}
      {currentScreen === 'hrms' && (
        <HrmsHomeScreen onBackToHome={() => setCurrentScreen('home')} />
      )}
    </div>
  );
}

export default App;
